var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButtonIconRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.29 62.74",
    style: {
      enableBackground: "new 0 0 63.29 62.74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DC0313;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7-0.05h13.83C52.04-0.05,63,10.91,63,24.43v13.83c0,13.52-10.96,24.47-24.47,24.47H24.7 c-13.52,0-24.47-10.96-24.47-24.47V24.43C0.22,10.91,11.18-0.05,24.7-0.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.02,29.97h18.36c0.7,0,1.26,0.56,1.26,1.26c0,0.7-0.57,1.26-1.26,1.26H22.02c-0.7,0-1.26-0.56-1.26-1.26 C20.75,30.54,21.32,29.97,22.02,29.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.12,22.88c0.32,0,0.65,0.12,0.89,0.37l7.09,7.09c0.49,0.49,0.49,1.28,0.01,1.77l-7.09,7.3 c-0.49,0.5-1.29,0.51-1.79,0.03c-0.5-0.49-0.51-1.29-0.03-1.79l6.23-6.41l-6.21-6.21c-0.49-0.49-0.49-1.29,0-1.79 C33.47,23.01,33.79,22.88,34.12,22.88z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonIconRed);
export default __webpack_public_path__ + "static/media/menu-button-icon-red.7cc1f212da58e88856f8db20e4b99a0b.svg";
export { ForwardRef as ReactComponent };